/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import type { InterfaceGenerateIframeSizing } from '../@types/interfaces/GenerateIframe';

export const generateIframeSizingAttributes = (arg: InterfaceGenerateIframeSizing) => {
  const { active, ...sizing } = arg || {};

  // In case of misuse
  if (!active) {
    return {
      style: {
        width: '100%',
        height: 'auto',
        border: 0,
      },
      'data-active-sizing': 2,
    };
  }

  switch (active) {
    case 2: {
      const activeTwoStyle = { ...sizing.sizing2, border: 0 };
      return {
        style: activeTwoStyle,
        'data-active-sizing': active,
        'data-width': activeTwoStyle.width,
        'data-height': activeTwoStyle.height,
      };
    }
    default: {
      const { horizontal, vertical } = sizing?.sizing1 || {};
      const aspectRatio = `${Number(horizontal) / Number(vertical)}`;
      return {
        style: {
          aspectRatio,
          border: 0,
          height: 'auto',
          minHeight: '150px', // Minimum height to prevent collapse
          width: '100%',
        },
        'data-active-sizing': active,
        'data-aspect-ratio': aspectRatio,
      };
    }
  }
};
